import axiosClient from '../../../../../axiosClient'

export default async (backgroundRequestId) => {
    const result = await axiosClient.get(`/background-check-form-progress/${backgroundRequestId}`)

    return result.data?.consentUrl ?? ""
}
